import './components/menu';


(function (w, $) {
    'use strict';

    $(document).ready(function() {
        scrollToTop();
		toggleMobileMenu();
        toggleHelplineSection();
    });

    function scrollToTop() {
        const backToTopLink = $('.footer-top-bar__back-to-top');

        if (!backToTopLink.length) return;

        backToTopLink.on('click', function(e) {
            e.preventDefault();

            $('html, body').animate({
                scrollTop: 0
            }, 800);
        });
    }

	function toggleMobileMenu() {

		const mainHeader = $('.main-header');
		const mobileMenuToggle = $('.header-mobile-toggle');
		const body = $('body');

		if (!mobileMenuToggle.length) return;

		mobileMenuToggle.on('click', function(e) {
			e.preventDefault();

			mainHeader.toggleClass('mobile-menu-open');
			body.toggleClass('mobile-menu-open');
		});
	}
    
    function toggleHelplineSection() {

        // toggle when clicking chevron area
        $('.helpline-section').on('click', '.helpline-card__toggle', function(e) {
            e.preventDefault();

            $(this).parent().next().slideToggle();
            $(this).parents('.helpline-card').toggleClass('is-open');
        });
    }

})(window, jQuery);


